import { BidDomainSelectModelSchema } from '@mntn-dev/domain-types'
import type { ZodInfer } from '@mntn-dev/utility-types'

import { SelectBidOutputSchema } from './select-bid.models.ts'

export const RejectBidInputSchema = BidDomainSelectModelSchema.pick({
  bidId: true,
})

export type RejectBidInput = ZodInfer<typeof RejectBidInputSchema>

export const RejectBidOutputSchema = SelectBidOutputSchema

export type RejectBidOutput = ZodInfer<typeof RejectBidOutputSchema>
